export class Construction {
  public constructor(
    public constructionId: string,
    public ejectorType: string,
    public ejectorTypeDescription: string,
    public authorizationGroup: string,
    public constructionDescription: string,
    public designId: string,
    public mouldTypeId: string,
    public machineTypeId: string,
    public boxConceptId: string,
    public boxLayoutId: string,
    public numberOfElements: number,
    public gateOpening: number,
    public ejectorTap: string,
    public numberOfInserts: number,
    public inductiveSensor: boolean,
    public mouldTypeDescription: string,
    public machineTypeDescription: string,
    public boxConceptDescription: string,
    public boxLayoutDescription: string
  ) {}
}
